<template>
  <div style="display: flex; flex-direction: column; height: 100%; width: 100%">
    <v-virtual-scroll
      class="flex-grow-1"
      item-height="97"
      :items="channels">
      <template v-slot:default="{ item }">
        <WideCard
          @keyup.enter="handleAssign(item.did)"
          @click="$emit('update:modelValue', item.did)"
          :loading="false"
          :title="deluge.items?.[item.did].name"
          :selected="modelValue === item.did"
          :img="findFirstAsset(deluge.channels?.[item.did].live_scene)"
          :dense="true">
          <Tag
            v-for="frame in getChFrames(deluge.items?.[item.did])"
            :key="frame.id"
            dense
            :color="frame.color"
            :icon="`mdi-numeric-${frame.number}-box`" />
          <Tag
            icon="mdi-playlist-play"
            dense
            :name="deluge.items?.[item.did].stats.q" />
          <Tag
            icon="mdi-cube-outline"
            dense
            :name="deluge.items?.[item.did].stats.s" />
        </WideCard>
      </template>
    </v-virtual-scroll>

    <div class="d-flex pt-3 align-center">
      <v-btn
        v-if="currentChannelDid"
        variant="tonal"
        prepend-icon="mdi-close-thick"
        @click="$emit('delete')">
        Remove Channel
      </v-btn>
      <v-spacer />
      <v-btn
        color="primary"
        variant="flat"
        :loading="loading"
        :disabled="!modelValue || modelValue === currentChannelDid"
        @click="handleAssign(modelValue)">
        <v-icon class="mr-2">mdi-content-save</v-icon>
        Assign
      </v-btn>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { deluge } from '@/stores/deluge.js';
import WideCard from '../../Shared/WideCard.vue';
import Tag from '../../Shared/Tag.vue';
import { getThumbnailForScene } from '@/utils/thumbnails.js';

const props = defineProps({
  modelValue: {
    type: String,
    default: '',
  },
  // New props required from the parent to manage button state
  currentChannelDid: {
    type: String,
    default: null,
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update:modelValue', 'assign', 'delete']);

const channels = computed(() => Object.values(deluge.channels));

function handleAssign(did) {
  // Guard against assigning when disabled
  if (!did || did === props.currentChannelDid) return;
  emit('assign', did);
}

function getChFrames(ch) {
  if (!ch) return [];
  let frames = [];
  for (const frame of Object.values(deluge.frames)) {
    if (frame.channel_id === ch.id) {
      frames.push(frame);
    }
  }
  return frames;
}

function findFirstAsset(scene) {
  const r = getThumbnailForScene(scene, deluge);
  return r.src;
}
</script>

<style scoped>
/* Ensure footer styling is consistent if defined elsewhere */
.modal-footer {
  border-top: 1px solid rgba(var(--v-border-color), var(--v-border-opacity));
}
</style>
